export const CONTACT_US = "New Contact Form Message";
export const CONSULTATION = "New Consultation Request";
export const ANALYST = "New Analyst Inquiry";
export const SALES = "New Sales Inquiry";
export const TECH_SUPPORT = "New Technical Support Inquiry";
export const CUSTOM_RESEARCH = "New Custom Research Request";
export const RENEWAL = "New Renewal Request";
export const BUY_REPORT = "Request to Buy Report";
